import { i18n } from '@/i18n'
import store from '@/store'
export default () => {
  // Permisos
  const role = store.getters['auth/role']

  const hasModuleVacacionesAEAT = store.getters['auth/hasModuleVacacionesAEAT']
  const hasModuleAgrupaciones = store.getters['auth/hasModuleAgrupaciones']

  const hasModuleCustomSMTPZerocoma = store.getters['auth/hasModuleCustomSMTPZerocoma']
  const hasModuleCustomSMTPCliente = store.getters['auth/hasModuleCustomSMTPCliente']
  const hasModuleCustomMails = store.getters['auth/hasModuleCustomMails']
  const hasModuleCustomLogo = store.getters['auth/hasModuleCustomLogo']
  const hasModuleCustomColors = store.getters['auth/hasModuleCustomColors']

  const hasModuleHorariosDescarga = store.getters['auth/hasModuleHorariosDescarga']
  const hasModuleCalendariosFestivosDescarga = store.getters['auth/hasModuleCalendariosFestivosDescarga']

  const hasAnyImportaciones = store.getters['auth/hasAnyImportaciones']

  const hasModuleFlujoEstadosAvisos = store.getters['auth/hasModuleFlujoEstadosAvisos']

  const hasModulePresentacionesAEAT = store.getters['auth/hasModulePresentacionesAEAT']

  const hasModuleOrgProvinces = store.getters['auth/hasModuleOrgProvinces']
  const hasModuleAPIRequests = store.getters['auth/hasModuleAPIRequests']

  const hasModuleContestacionDiligencias = store.getters['auth/hasModuleContestacionDiligencias']

  const hasOcultarInformacionEmpresasCertificados = store.getters['auth/hasOcultarInformacionEmpresasCertificados']

  const hasModuleAsistenciaIA = store.getters['auth/hasModuleAsistenciaIA']

  // Menu base
  let menu = [
    {
      icon: 'companies',
      name: i18n.t('app.companies'),
      path: 'companies',
      registerNavFromMenu: true,
      sc: [] // Child options
    },
    {
      icon: 'certificates',
      name: i18n.t('app.certificates'),
      path: 'certificates',
      registerNavFromMenu: true,
      sc: [] // Child options
    }
  ]
  if (hasOcultarInformacionEmpresasCertificados) {
    if (role === 'Usuario' || role === 'UsuarioConsulta') {
      // Si es usuario con ocultación, vaciar el menú
      menu = []
    }
  }
  if (hasModuleContestacionDiligencias) {
    if (role !== 'UsuarioConsulta') {
      // Si tiene el módulo de contestación de diligencias y no es UsuarioConsulta, añadir acceso directo a procedings
      menu.unshift({
        icon: 'procedingmenu',
        name: i18n.t('procedings.title'),
        path: 'procedings',
        registerNavFromMenu: false,
        sc: [] // shorcuts
      })
    }
  }

  // Excepción de NEOS para AdminDistribuidor
  const neos = {
    icon: 'notification',
    name: i18n.t('app.notifications'),
    path: 'notifications',
    registerNavFromMenu: true,
    sc: [] // Child options
  }
  if (role !== 'AdminDistribuidor') {
    menu.unshift(neos)
  }

  if (role !== 'Usuario' && role !== 'UsuarioConsulta') {
    // Config principal base
    const config = {
      icon: 'config',
      name: i18n.t('app.configurations'),
      path: role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
      registerNavFromMenu: true,
      sc: [
      ] // Child options
    }

    // Config multiples niveles
    const configMultipleLevels = {
      icon: 'config',
      name: i18n.t('app.configurations'),
      path: role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
      registerNavFromMenu: true,
      subMenu: true,
      sc: [
        {
          desplegado: true,
          name: 'Básica',
          sc: []
        },
        {
          desplegado: false,
          name: 'Avanzada',
          sc: []
        },
      ] 
    }

    // menus de configuración:
    const configTemplateClients = {
      icon: 'chevronright',
      name: i18n.t('distributors.template_clients'),
      path: 'configurations/template/clients',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configTemplateClientsPersonalization = {
      icon: 'chevronright',
      name: i18n.t('distributors.template_clients_personalization'),
      path: 'configurations/template/clientspersonalization',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configTemplateClientsHorarioDescarga = {
      icon: 'chevronright',
      name: i18n.t('distributors.template_clients_horario_descarga'),
      path: 'configurations/template/clientsdownloadschedule',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configTemplateCalendariosFestivosDescarga = {
      icon: 'chevronright',
      name: i18n.t('distributors.template_clients_calendario_festivos'),
      path: 'configurations/template/clientsholidaycalendar',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configUsers = {
      icon: 'chevronright',
      name: i18n.t('app.users'),
      path: 'configurations/users',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configGroups = {
      icon: 'chevronright',
      name: i18n.t('app.groups'),
      path: 'configurations/groups',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configGrouping = {
      icon: 'chevronright',
      name: i18n.t('app.grouping'),
      path: 'configurations/grouping/companies/main',
      registerNavFromMenu: true,
      sc: [] // shorcuts
    }
    const configRules = {
      icon: 'chevronright',
      name: i18n.t('app.rules'),
      path: 'configurations/rules',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configLocations = {
      icon: 'chevronright',
      name: role === 'Administrador' ? i18n.t('app.locations_hired') : i18n.t('app.locations'),
      path: 'configurations/locations',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configTemplate = {
      icon: 'chevronright',
      name: i18n.t('app.template'),
      path: 'configurations/template/companies',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configTemplateGroups = {
      icon: 'chevronright',
      name: i18n.t('app.template_groups'),
      path: 'configurations/template/groups',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configVacacionesAEAT = {
      icon: 'chevronright',
      name: i18n.t('clients.courtesydaysaeat'),
      path: 'configurations/courtesydaysaeat',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configRepresentative = {
      icon: 'chevronright',
      name: i18n.t('clients.representative'),
      path: 'configurations/representative',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configPersonalization = {
      icon: 'chevronright',
      name: i18n.t('clients.personalization'),
      path: 'configurations/personalization',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configHorarioDescarga = {
      icon: 'chevronright',
      name: i18n.t('clients.horario_descarga'),
      path: 'configurations/downloadschedule',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configHorarioAIAssist = {
      icon: 'chevronright',
      name: i18n.t('clients.ai_assist'),
      path: 'configurations/configaiassist',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configCalendariosFestivosDescarga = {
      icon: 'chevronright',
      name: i18n.t('clients.calendario_festivos'),
      path: 'configurations/holidaycalendar',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configDistributors = {
      icon: 'chevronright',
      name: i18n.t('distributors.header'),
      path: 'configurations/distributors',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configClients = {
      icon: 'chevronright',
      name: i18n.t('app.clients'),
      path: 'configurations/clients',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configGeneral = {
      icon: 'chevronright',
      name: i18n.t('app.config_general'),
      path: 'configurations/general',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configMaestroDocumentos = {
      icon: 'chevronright',
      name: i18n.t('documentmaster.documentmaster'),
      path: 'configurations/documentmaster',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configImportaciones = {
      icon: 'chevronright',
      name: i18n.t('imports.imports'),
      path: 'configurations/imports',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configFlujoEstadosAvisos = {
      icon: 'chevronright',
      name: i18n.t('app.configflow'),
      path: 'configurations/configflow',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configOrgProvinces = {
      icon: 'chevronright',
      name: i18n.t('app.orgprovinces'),
      path: 'configurations/orgprovinces',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    const configAPIRequests = {
      icon: 'chevronright',
      name: i18n.t('app.apirequests'),
      path: 'configurations/apirequests',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    // const configDeclaracionDiligencias = {
    //   icon: 'chevronright',
    //   name: i18n.t('procedings.title'),
    //   path: 'procedings',
    //   registerNavFromMenu: false,
    //   sc: [] // shorcuts
    // }

    if (role === 'Administrador') {
      // Arbol múltiple
      configMultipleLevels.sc[0].sc.push(configGeneral)
      configMultipleLevels.sc[0].sc.push(configUsers)
      configMultipleLevels.sc[0].sc.push(configGroups)
      configMultipleLevels.sc[0].sc.push(configRules)
      configMultipleLevels.sc[0].sc.push(configLocations)

      configMultipleLevels.sc[1].sc.push(configTemplate)
      configMultipleLevels.sc[1].sc.push(configTemplateGroups)

      if (hasModuleAgrupaciones) configMultipleLevels.sc[1].sc.push(configGrouping)
      if (hasModuleVacacionesAEAT) configMultipleLevels.sc[1].sc.push(configVacacionesAEAT)

      configMultipleLevels.sc[1].sc.push(configRepresentative)
      
      if (hasModuleFlujoEstadosAvisos) configMultipleLevels.sc[1].sc.push(configFlujoEstadosAvisos)
      if (hasModuleOrgProvinces) configMultipleLevels.sc[1].sc.push(configOrgProvinces)
      if (hasModuleAPIRequests) configMultipleLevels.sc[1].sc.push(configAPIRequests)
      // if (hasModuleContestacionDiligencias) configMultipleLevels.sc[1].sc.push(configDeclaracionDiligencias)

      if (hasModuleCustomSMTPCliente || 
        hasModuleCustomMails || 
        hasModuleCustomLogo || 
        hasModuleCustomColors || 
        (hasModuleCustomSMTPZerocoma && role === 'SuperAdministrador')
      ) configMultipleLevels.sc[1].sc.push(configPersonalization)

      if (hasModuleHorariosDescarga) configMultipleLevels.sc[1].sc.push(configHorarioDescarga)
      if (hasModuleCalendariosFestivosDescarga) configMultipleLevels.sc[1].sc.push(configCalendariosFestivosDescarga)

      if (hasModulePresentacionesAEAT) configMultipleLevels.sc[1].sc.push(configMaestroDocumentos)
      if (hasModuleAsistenciaIA) configMultipleLevels.sc[1].sc.push(configHorarioAIAssist)
      if (hasAnyImportaciones) configMultipleLevels.sc[1].sc.push(configImportaciones)

      menu.push(configMultipleLevels)
    } else if (role === 'SuperAdministrador') {
      // Arbol simple
      config.sc.push(configDistributors)
      config.sc.push(configClients)
      config.sc.push(configUsers)
      config.sc.push(configGroups)
      config.sc.push(configRules)
      config.sc.push(configFlujoEstadosAvisos)
      config.sc.push(configOrgProvinces)
      config.sc.push(configAPIRequests)
      // config.sc.push(configDeclaracionDiligencias)
      config.sc.push(configLocations)
      config.sc.push(configMaestroDocumentos)
      config.sc.push(configImportaciones)

      menu.push(config)
    } else {
      // Arbol múltiple Distribuidores
      configMultipleLevels.sc[0].sc.push(configGeneral)
      configMultipleLevels.sc[0].sc.push(configClients)
      configMultipleLevels.sc[0].sc.push(configUsers)
      configMultipleLevels.sc[0].sc.push(configGroups)
      configMultipleLevels.sc[0].sc.push(configRules)
      configMultipleLevels.sc[0].sc.push(configLocations)

      
      configMultipleLevels.sc[1].sc.push(configTemplateClients)
      if (hasModuleFlujoEstadosAvisos) configMultipleLevels.sc[1].sc.push(configFlujoEstadosAvisos)
      if (hasModuleOrgProvinces) configMultipleLevels.sc[1].sc.push(configOrgProvinces)
      if (hasModuleAPIRequests) configMultipleLevels.sc[1].sc.push(configAPIRequests)

      if (hasModuleCustomSMTPCliente || hasModuleCustomMails || hasModuleCustomLogo || hasModuleCustomColors) { 
        configMultipleLevels.sc[1].sc.push(configTemplateClientsPersonalization) 
      }
      if (hasModuleHorariosDescarga) configMultipleLevels.sc[1].sc.push(configTemplateClientsHorarioDescarga)

      if (hasModuleCalendariosFestivosDescarga) configMultipleLevels.sc[1].sc.push(configTemplateCalendariosFestivosDescarga)

      if (hasModulePresentacionesAEAT) configMultipleLevels.sc[1].sc.push(configMaestroDocumentos)
      if (hasAnyImportaciones) configMultipleLevels.sc[1].sc.push(configImportaciones)

      menu.push(configMultipleLevels)
    }

    // Papelera
    const trash = {
      icon: 'trash',
      name: i18n.t('app.trash'),
      path: role === 'AdminDistribuidor' ? 'trashad' : 'trash',
      registerNavFromMenu: true,
      sc: [
        {
          icon: 'chevronright',
          name: i18n.t('app.companies'),
          path: 'trash/companies',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('app.certificates'),
          path: 'trash/certificates',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('app.users'),
          path: 'trash/users',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          icon: 'chevronright',
          name: i18n.t('app.groups'),
          path: 'trash/groups',
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
      ] // Child options
    }
    const trashNeos = {
      icon: 'chevronright',
      name: i18n.t('app.notifications'),
      path: 'trash/notifications',
      registerNavFromMenu: false,
      sc: [] // shorcuts
    }
    
    if (role !== 'AdminDistribuidor') {
      trash.sc.unshift(trashNeos)
    }
   
    menu.push(trash)
  }

  return menu
}
